export default __webpack_public_path__ + "static/media/clock_close.071b095e.svg";